import { preloadFirebase } from "~/utils/firebase";

export default defineNuxtPlugin(() => {
	const schedulePreload = () => {
		preloadFirebase();
	};

	if ("requestIdleCallback" in window) {
		window.requestIdleCallback(schedulePreload, { timeout: 3000 });
		return;
	}

	window.setTimeout(schedulePreload, 2000);
});
